import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import { IReferencia } from "@/Models/Financeiro/Titulo/Origem";
import Titulo, { EnumTituloTipo } from "@/Models/Financeiro/Titulo/Titulo";
import { useAtivar, useDesativar, useGerarLink } from "@/Services/Financeiro/Titulo/TituloService";
import { Button, Dropdown, Popconfirm } from "antd";
import { ReactNode } from "react";
import TituloVisualizarModal from "./TituloVisualizarModal";
import BoletoObterLinkFormModal from "./Pagamento/Boleto/BoletoObterLinkFormModal";
import TituloDublicarFormModal from "./TituloDublicarFormModal";
import FaturaDupliucarFormModal from "./Fatura/FaturaDuplicarFormModal";
import TituloPagamentoFormDrawer from "./Pagamento/TituloPagamentoFormDrawer";
import TituloMovimentacaoDrawer from "./TituloMovimentacao/TituloMovimentacaoDrawer";
import { EnumTituloSituacao } from "@/Models/Financeiro/Titulo/TituloSituacao";
import TituloFormDrawer from "./TituloFormDrawer";
import { EnumPessoaTipo } from "@/Models/Pessoa/Pessoa";
import { Link } from "react-router-dom";

function ButtonPagar({ codigo }: { codigo: number }) {
    const {
        mutate: mutateGerarLink,
        isPending: isPedingGerarLink
    } = useGerarLink({});

    const onClick = () => {
        const w = window.open()
        mutateGerarLink(codigo, {
            onSuccess: ({ data }) => {
                if(w) w.location.href = `/Financeiro/Pagamento?${data}&urlRedirectSucess=/Financeiro/Pagamento/Sucesso`;
            },
            onError: () => {
                if(w) w.close();
            }
        })
    };

    return <Button
        type='primary'
        size='small'
        style={{ 
            width: "100%",
            height: "100%"
        }}
        onClick={onClick}
        loading={isPedingGerarLink}
    >
        Pagar
    </Button>;
}

export interface IOpceosTituloProps<TReferencia extends IReferencia = any> {
    isDesativar?: boolean;
    isAtivar?: boolean;
    isPagar?: boolean;
    isVisualizar?: boolean;
    isFormasPagamento?: boolean;
    isAcessarFatura ?: boolean;
    onEditar?: (titulo: Titulo) => void;
    onSucess?: () => void;
    titulo:Titulo<TReferencia>;
    children:ReactNode;
}

export default function OpceosTitulo<TReferencia extends IReferencia = any> ({ 
    isDesativar,
    isAtivar,
    isPagar,
    isVisualizar,
    isFormasPagamento,
    isAcessarFatura,
    onEditar,
    titulo,
    children,
    onSucess,
    ...props
}:IOpceosTituloProps<TReferencia>) {
    const {
        mutate: mutateDesativar,
        isPending: isPedingDesativar
    } = useDesativar({
        onSuccess() {
            onSucess?.();
        }
    });

    const {
        mutate: mutateAtivar,
        isPending: isPedingAtivar
    } = useAtivar({
        onSuccess() {
            onSucess?.();
        }
    });

    return <>
        <Dropdown
            menu={{
                items : [
                    {
                        key : 1,
                        label : (isAtivar !== false && !titulo.ativo) && <ComponentePermissao permissoes={["FinanceiroTituloAtivar"]}>
                            <Popconfirm
                                title="Ativar"
                                description="Tem certeza que desja ativar este titulo?"
                                onConfirm={() => {
                                    mutateAtivar(titulo.codigo);
                                }}
                            >
                                <Button
                                    type='dashed'
                                    size='small'
                                    style={{
                                        width: "100%",
                                        height: "100%"
                                    }}
                                    loading={isPedingAtivar}
                                >Ativar</Button>
                            </Popconfirm>
                        </ComponentePermissao>
                    },
                    {
                        key : 2,
                        label : (isVisualizar !== false && titulo.codTipo !== EnumTituloTipo.Titulo) && <ComponentePermissao permissoes={["FinanceiroTituloBuscarCodigo"]}>
                            <TituloVisualizarModal
                                codigo={titulo.codigo}
                                propsButtonOpen={{
                                    style : {
                                        width: "100%",
                                        height: "100%"
                                    }
                                }}
                            />
                        </ComponentePermissao>
                    },
                    {
                        key : 3,
                        label : (isPagar !== false && titulo.codSituacao !== EnumTituloSituacao.Liquidado && titulo.codTipo !== EnumTituloTipo.Titulo && titulo.ativo && titulo.beneficiario?.tipo === EnumPessoaTipo.EMPRESA) && <ComponentePermissao permissoes={["FinanceiroTituloLinkGerar"]}>
                            <ButtonPagar codigo={titulo.codigo} />
                        </ComponentePermissao>
                    },
                    {
                        key : 4,
                        label : (isPagar !== false && titulo.codSituacao !== EnumTituloSituacao.Liquidado && titulo.codTipo !== EnumTituloTipo.Titulo && titulo.ativo && titulo.beneficiario?.tipo === EnumPessoaTipo.EMPRESA) && <ComponentePermissao permissoes={["FinanceiroTituloLinkGerar"]}>
                            <BoletoObterLinkFormModal 
                                codTitulo={titulo.codigo} 
                                propsButtonOpen={{
                                    style : {
                                        width: "100%",
                                        height: "100%"
                                    }
                                }}
                                textButtonOpen={"Imp. Boleto"}
                            />
                        </ComponentePermissao>
                    },
                    {
                        key : 5,
                        label : titulo.ativo && <ComponentePermissao permissoes={["FinanceiroTituloAlterar", "FinanceiroTituloBuscarCodigo"]}>
                            {
                                !!onEditar && <Button
                                    type='primary'
                                    size='small'
                                    style={{
                                        width: "100%",
                                        height: "100%"
                                    }}
                                    onClick={(_) => onEditar?.(titulo)}
                                >
                                    Editar
                                </Button> || <TituloFormDrawer
                                    acao={"alterar"}
                                    codTituloTipo={titulo.codTipo}
                                    formProps={{
                                        codigo : titulo.codigo,
                                        onSalvarSucesso : () => {
                                            // form.setFieldValue(["pagina", "pagina"], 1);
                                            // refetch();
                                            onSucess?.();
                                        }
                                    }}
                                >
                                    <Button
                                        type='primary'
                                        size='small'
                                        style={{
                                            width: "100%",
                                            height: "100%"
                                        }}
                                    >
                                        Editar
                                    </Button>
                                </TituloFormDrawer>
                            }
                        </ComponentePermissao>
                    },
                    {
                        key : "acessar-titulo",
                        label : (
                            isAcessarFatura !== false && titulo.codFatura != undefined && titulo.codFatura > 0
                        ) && <Button
                            type='dashed'
                            size='small'
                            style={{
                                width: "100%",
                                height: "100%"
                            }}
                        >
                            <Link target="_blank" to={`/financeiro/titulos/fatura/editar-ficha/${titulo.codFatura}`}>
                                Acessar título
                            </Link>
                        </Button>
                    },
                    {
                        key : 6,
                        label : (titulo.ativo && isDesativar !== false) && <ComponentePermissao permissoes={["FinanceiroTituloDesativar"]}>
                            <Popconfirm
                                title="Desativar"
                                description="Tem certeza que desja desativar este titulo?"
                                onConfirm={() => {
                                    mutateDesativar(titulo.codigo);
                                }}
                            >
                                <Button
                                    type='primary'
                                    danger
                                    size='small'
                                    style={{ 
                                        width: "100%",
                                        height: "100%"
                                    }}
                                    loading={isPedingDesativar}
                                >
                                    Desativar
                                </Button>
                            </Popconfirm>
                        </ComponentePermissao>
                    },
                    {
                        key : 'formas-pagamento',
                        label : (titulo.ativo && titulo.codTipo === EnumTituloTipo.Parcela && isFormasPagamento !== false) && <TituloPagamentoFormDrawer codTitulo={titulo.codigo}>
                            <Button
                                type='dashed'
                                size='small'
                                style={{
                                    width: "100%",
                                    height: "100%"
                                }}
                            >
                                Forma pagamento
                            </Button>
                        </TituloPagamentoFormDrawer>
                    },
                    {
                        key : 7,
                        label : titulo.ativo && titulo.codTipo === EnumTituloTipo.Parcela && <TituloMovimentacaoDrawer 
                            codTitulo={titulo.codigo} 
                            elementoGatilho={<Button
                                type='dashed'
                                size='small'
                                style={{
                                    width: "100%",
                                    height: "100%"
                                }}
                            >
                                Movimentação
                            </Button>
                        }></TituloMovimentacaoDrawer>
                    },
                    {
                        key : 8,
                        label : titulo.ativo && (
                            titulo.codTipo === EnumTituloTipo.Parcela && <TituloDublicarFormModal 
                                codTituloBase={titulo.codigo}
                                propsButtonOpen={{
                                    style : {
                                        width: "100%",
                                        height: "100%"
                                    }
                                }}
                            /> || <FaturaDupliucarFormModal 
                                codFatura={titulo.codigo} 
                                onSuccess={() => onSucess?.()} 
                                propsButtonOpen={{
                                    style : {
                                        width: "100%",
                                        height: "100%"
                                    }
                                }}    
                            />
                        )
                    }
                ].filter(f => f.label !== false)
            }}
        >
            {children}
        </Dropdown>
    </>
}